import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import Loading from 'components/Loading/index';
import api from 'api';
import Util from 'utility';

const recommendedItemCls = 'inline-flex items-center basis-full justify-between border border-[#ccc] mr-[0.5em] mb-[0.5em] px-[0.5em] py-[0.25em] hover:border-[#26AA52] hover:bg-[#e9f5e5] no-underline text-inherit cursor-pointer';

function PanelRecommendFoods({ attr, ddd, onFoodAdded }) {
    const data = useSelector(state => state);
    const { globals } = data;
    const [foods, setFoods] = useState([]);
    const [selectedFoodId, setSelectedFoodId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api('foods2/recommended/' + attr).then(res => {
            setFoods(res.data.foods);
            setLoading(false);
        });
    }, [attr]);

    if(loading) return <Loading />;

    const lowerFirst = s => s.charAt(0).toLowerCase() + s.slice(1);
    const profileId = Util.getFirstProfileId();
    const undesirableFoods = globals.undesirableFoods[profileId];
    const amountToOptimum = Math.ceil(ddd.amount_to_optimum);

    if(selectedFoodId !== null) {
        const meals = Object.keys(data.meals).map(m => {
            const meal = data.meals[m];
            const foodGroups = Object.keys(data.foodGroups[m]).map(fg => {
                const fgroup = data.foodGroups[m][fg];
                const addFood = () => {
                    const dateString = format(data.plannerDate, 'yyyy-MM-dd');
                    api('foods2/insert-recommended/' + dateString + '/' + m + '/' + fg, { post: true, data: { id: selectedFoodId } })
                        .then(() => setTimeout(onFoodAdded, 1000));
                };
                return <p key={fg}><a className="inline-block py-[0.5em] px-[1.5em] bg-[#26AA52] text-white no-underline rounded cursor-pointer" onClick={addFood}>{fgroup.title}</a></p>;
            });
            return (
                <div className="[&>h3]:text-[#26AA52]" key={m}>
                    <h3>{globals.mealTypes[meal.mealId].title}</h3>
                    {foodGroups}
                </div>
            );
        });
        return (
            <div>
                <h3 className="text-black my-[2em] mb-[1em] first:mt-0 text-[1.1em] font-normal">{globals.itemData[selectedFoodId].title} - přidat do:</h3>
                {meals}
            </div>
        );
    }

    const sortedFoods = [...foods].sort((a, b) => a.item_order - b.item_order);
    const categories = sortedFoods.map((category, idx) => {
        const foodItems = category.foods.map(f => {
            const optimumAmount = Math.ceil((amountToOptimum / f.value) * f.weight);
            const undesirableWarning = undesirableFoods.includes(f.id)
                ? <p style={{margin:'4px 0 0',color:'red',fontSize:'11px',fontWeight:'bold'}}><i className="fa fa-exclamation-triangle"></i> nevhodné pro {globals.profiles[profileId].name}</p>
                : null;
            return (
                <a key={f.id} onClick={() => setSelectedFoodId(f.id)} className={recommendedItemCls}>
                    <div className="basis-[50px] h-[50px] bg-center bg-no-repeat shrink-0" style={{ backgroundSize:'contain', backgroundImage: `url(https://www.zofapp.cz/data/zof/item/${f.id}.svg)` }}></div>
                    <div className="basis-[calc(100%-60px-1em)] [&>p]:m-0 [&>p]:text-[0.9em]">
                        <p><b>{globals.itemData[f.id].title} ({parseFloat(f.weight)} {f.weight_unit})</b></p>
                        <p>Obsahuje {parseFloat(f.value)} {globals.attribute_units[attr]} {lowerFirst(globals.attributes_inflected[attr])}.</p>
                        <p>Pro dosažení optima je třeba navýšit o {optimumAmount} {f.weight_unit}</p>
                        {undesirableWarning}
                    </div>
                </a>
            );
        });
        return (
            <div key={idx}>
                <h3 className="text-black my-[2em] mb-[1em] first:mt-0 text-[1.1em] font-normal">{category.category_title}:</h3>
                <div className="flex flex-wrap mb-[2em]">{foodItems}</div>
            </div>
        );
    });

    return (
        <div style={{ display: 'flex', flex: 1, flexDirection: 'column', maxHeight:'500px', overflowY:'scroll' }}>
            {categories}
        </div>
    );
}

export default PanelRecommendFoods;
